const SecondContent = () => {
	return (
		<section className="sub-content cont2">
			<div className="sub-inner">
				<div className="promotion-event">
					<div className="promotion-event-image">
						<i className="ico"></i>
						<p className="align-center">
							지금 스텔라에
							<br />
							가입하세요!
						</p>
					</div>
					<ul>
						<li>
							<div className="event-group">
								<p className="sub">이벤트 1.</p>
								<p className="desc">
									가입비 <span>최초 1회 10만원</span>
									<br />
									<strong>무료 프로모션 중</strong>
								</p>
							</div>
						</li>
						<li>
							<div className="event-group">
								<p className="sub">이벤트 2.</p>
								<p className="desc">
									신규가입 시 무료체험 <br />
									<strong>가입 월 포함 2개월</strong>
								</p>
							</div>
						</li>
					</ul>
				</div>
				<div className="promotion-information">
					<ul>
						<li>
							<i className="ico1"></i>
							<span className="font-bold">무제한</span> 전자세금계산서 발행
						</li>
						<li>
							<i className="ico2"></i>
							<span className="font-bold">20,000포인트</span> 제공
						</li>
						<li>
							<i className="ico3"></i>
							ERP사 유일 <span className="font-bold">거래처 신용정보</span> 제공
						</li>
						<li>
							* 추가 기능은 <span className="font-bold point">무료 체험 종료 후</span> 이용할 수 있어요!
						</li>
					</ul>
				</div>
			</div>
			<div className="sub-inner">
				<strong className="title">기본 서비스</strong>
				<ul className="free-service">
					{/* 경영보고서 */}
					<li className="free-service-list">
						<i className="ico0"></i>
						<strong>경영보고서</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">사업현황보고서, 매출/매입/이익 현황</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">외상 매출/매입 보고서, 매출/비용 보고서</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전계좌 현황관리, 인사/급여 현황관리, 재고 현황관리</span>
							</li>
						</ul>
					</li>
					{/* 거래 수집 */}
					<li className="free-service-list">
						<i className="ico1"></i>
						<strong>거래 수집</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">세금계산서,현금영수증 매출/매입 내역 수집</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">여신금융협회 카드매출/입금예정 내역 수집</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전 카드사 사용 내역 수집</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전 은행 거래 내역 수집</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">수집된 거래내역 계정과목 추천 및 자동분개 제공</span>
							</li>
						</ul>
					</li>
					{/* 매입/매출 관리 */}
					<li className="free-service-list">
						<i className="ico2"></i>
						<strong>매입/매출 관리</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">증빙유형에 맞는 자동분개 입력</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">세금계산서 작성/발행 및 홈택스 전송</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">홈택스 즉시전송/익일전송 제공</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">거래명세서 작성 및 거래처발송</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전표 일괄 업로드/삭제, 복사 기능 제공</span>
							</li>
						</ul>
					</li>
				</ul>
				<ul className="free-service">
					{/* 금융관리 */}
					<li className="free-service-list">
						<i className="ico3"></i>
						<strong>금융관리</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전 은행 이체기능 제공(일반/집금/대금/급여)</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전 은행 입/출금 계좌 관리(계좌 수 무제한)</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">카드 사용 내역 및 청구서 조회(카드 수 무제한)</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">
									계좌 현황/카드 현황에 대한 요약 대시보드 제공 <br />
									(전월 대비 내역 비교 기능 등)
								</span>
							</li>
						</ul>
					</li>
					{/* 인사/급여/4대보험 */}
					<li className="free-service-list">
						<i className="ico4"></i>
						<strong>인사/급여/4대보험</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">사원대장 및 다양한 인사총무양식 제공</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">급여, 상여, 퇴직금 소득세 및 공제금액 자동계산</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">급여지급내역 자동전표 처리</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">급여명세서 작성 및 발행</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">4대보험 신고(취득, 상실, 피부양자 신고)</span>
							</li>
						</ul>
					</li>
					{/* 보고서/재무제표 */}
					<li className="free-service-list">
						<i className="ico5"></i>
						<strong>보고서/재무제표</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">미수/미지급 보고서, 기간 손익보고서</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">일/월계표, 자금일보</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">결산회계처리 분개 자동생성</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">
									비교식 재무제표 제공(합계잔액시산표, 재무상태표, <br />
									손익계산서, 원가명세서, 이익잉여금처분계산서)
								</span>
							</li>
						</ul>
					</li>
				</ul>
				<ul className="free-service">
					{/* 부가세/원천세 신고 */}
					<li className="free-service-list">
						<i className="ico6"></i>
						<strong>부가세/원천세 신고</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">
									거래처 재무상세, 일반개요 정보
									<br /> 조회 가능
								</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">홈택스 연동 거래처 자동 등록 기능 제공</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">거래처 실시간 휴폐업조회 기능 제공</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">거래처별 외상금액(매출/매입) 관리 제공</span>
							</li>
						</ul>
					</li>
					{/* 재고관리 */}
					<li className="free-service-list">
						<i className="ico7"></i>
						<strong>재고관리</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">재고이동, 조정 등 입/출고 관리</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">선입선출, 이동평균법 제공</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">이익현황, 재고잔량 분석</span>
							</li>
						</ul>
					</li>
					{/* 영업관리 */}
					<li className="free-service-list">
						<i className="ico8"></i>
						<strong>영업관리</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">세금계산서 작성 및 홈택스 전송</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">거래명세서 작성 및 거래처 발송</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">전표 작성 및 관리</span>
							</li>
						</ul>
					</li>
					{/* 제증명발급 */}
					<li className="free-service-list">
						<i className="ico9"></i>
						<strong>제증명발급</strong>
						<ul>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">홈택스 6종 발급</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">대법원 2종 발급</span>
							</li>
							<li>
								<span className="dot">&#x2022;</span>
								<span className="txt">정부24 3종 발급</span>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default SecondContent;
